import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Avatar,
  Box,
} from "@mui/material";
import React, { Fragment, useMemo, useState } from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import FlexButton from "../FlexButton";
import { colors } from "../../assets/colors";
import {
  formatAsPercentage,
  graphDataMaker,
  setCryptoDecimals,
} from "../../utils";
import TableChart from "../TableChart";
import { useNavigate } from "react-router";
import ErrorModal from "../modals/ErrorModal";

export default function CurrencyList({
  coinList,
  webSocketCoinList,
  activeTabs,
  search,
}) {
  const makeTableData = useMemo(() => {
    return (
      coinList &&
      coinList.map((item) => {
        const findData =
          webSocketCoinList &&
          webSocketCoinList.find((x) => x.symbol === item.symbol);

        return { ...findData, ...item };
      })
    );
  }, [coinList, webSocketCoinList]);

  // console.log(makeTableData);

  //function to sort the data according to the active tab
  function sortData(activeButtonType) {
    let sortedData = [...makeTableData];

    switch (activeButtonType) {
      case "highest_volume":
        sortedData.sort((a, b) => b.volume_24h - a.volume_24h);
        break;
      case "top_gainers":
        sortedData.sort((a, b) => b.percent_change_1h - a.percent_change_1h);
        break;
      case "top_losers":
        sortedData.sort((a, b) => a.percent_change_1h - b.percent_change_1h);
        break;
      default:
        // Default sorting by highest volume
        sortedData.sort((a, b) => b.volume_24h - a.volume_24h);
        break;
    }

    return sortedData;
  }

  //function to render the final list according to the search field and sorting tab
  const currentTabData = useMemo(() => {
    if (search === "") {
      return sortData(activeTabs);
    } else {
      return makeTableData.filter((item) => {
        return (
          item?.symbol?.toLowerCase().indexOf(search?.toLowerCase()) !== -1
        );
      });
    }
  }, [activeTabs, makeTableData, search]);

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Trading Pairs</TableCell>
            <TableCell align="center">Last Traded Price</TableCell>
            <TableCell align="left">1H Change</TableCell>
            <TableCell align="center">Charts</TableCell>
            <TableCell align="center">Trade</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentTabData &&
            currentTabData.slice(0, 10)?.map((item, i) => {
              if (item === undefined) {
                return;
              }
              if (item?.currency_type?.toUpperCase() === item?.symbol) {
                return;
              }
              return <MainTableRow item={item} key={`listItem${i}`} />;
            })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

const MainTableRow = ({ item }) => {
  const navigate = useNavigate();
  const [error, setError] = useState(false);
  return (
    <Fragment>
      <TableRow>
        <TableCell
          align="center"
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Avatar
            src={item && item.icon}
            alt="coin_img"
            style={{ marginRight: "10px" }}
          />

          {item && item.symbol}
        </TableCell>
        <TableCell align="center">
          {item &&
            `$${setCryptoDecimals(item.price ? item.price : item?.usdt_price)}`}
        </TableCell>
        <TableCell
          align="center"
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {item && item.percent_change_1h > 0 ? (
            <ArrowUpwardIcon style={{ color: "#5CE046" }} />
          ) : (
            <ArrowDownwardIcon style={{ color: "#E04646" }} />
          )}
          {item &&
            formatAsPercentage(
              item.percent_change_1h
                ? item.percent_change_1h
                : item.price_change_percentage_1h
            )}
        </TableCell>
        <TableCell sx={{ padding: "0px" }}>
          <Box
            style={{
              height: "70px",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <TableChart
              chartData={item && item.ohlcData && graphDataMaker(item.ohlcData)}
              graphColor={
                item && item.percent_change_1h > 0 ? "#4ed46c" : "#ec1f24"
              }
              name={item && item.symbol}
            />
          </Box>
        </TableCell>
        <TableCell align="center">
          <FlexButton
            title="Trade"
            sx={{
              backgroundColor: "transparent",
              color: colors.btnGold,
              border: `1px solid ${colors.btnGold}`,
            }}
            color="default"
            // onClick={() => {

            //   const checkPair = item?.paired_string
            //     ? item?.paired_string?.includes(selectedCurrency?.toUpperCase())
            //     : false;
            //   const pair = item?.paired_string
            //     ? item?.paired_string?.split(",")[0]
            //     : "INR";
            //   if (checkPair) {
            //     navigate(
            //       `/trade/spot-trading?${item?.symbol}/${pair?.toUpperCase()}`
            //     );
            //   } else {
            //     setError(true);
            //   }
            // }}
          />
        </TableCell>
      </TableRow>
      {error && (
        <ErrorModal
          open={error}
          close={() => setError(false)}
          title="Sorry!!!"
          description={"We are not currently trading in this pair!."}
        />
      )}
    </Fragment>
  );
};
